/**
 * Sincroniza isScrolledInput / isScrolled con window.scrollY.
 * El listener vive aquí (no en SearchInput) para que el estado se actualice
 * aunque el input del header se monte/desmonte al volver al top en home.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const scrollStore = useScrollStore()

  const sync = () => {
    nextTick(() => {
      requestAnimationFrame(() => {
        scrollStore.checkScrollInput()
      })
    })
  }

  const onScroll = () => {
    scrollStore.checkScrollInput()
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('scrollend', onScroll, { passive: true })
  window.addEventListener('resize', onScroll, { passive: true })

  sync()

  router.afterEach(() => {
    sync()
  })
})
